import { BasketballIcon } from './BasketballIcon';

/**
 * author: Google
 * id FD797202-9EF1-407E-A290-97C014B8F37E
 * name basketball
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/basketball.svg
 * tags
 * - Sport 
 */
export const YoutubeSportsIcon = BasketballIcon;
export default YoutubeSportsIcon